<page-heading
  [title]="'integrations.pipedriveForm.pageTitle' | translate"
  [description]="'integrations.pipedriveForm.pageDescription' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

@if (loadingContent) {
<content-loading-list />
}

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-xs-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-xs-12 mb-3">
              <label class="form-label">{{ 'integrations.pipedriveForm.configNameLabel' | translate }}</label>
              <input
                type="text"
                class="form-control"
                maxlength="255"
                formControlName="name"
                [placeholder]="'integrations.pipedriveForm.configNamePlaceholder' | translate"
                required
              />
              <field-error-component
                [field]="'name'"
                [label]="'integrations.fields.name' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-xs-12 mb-3">
              <div class="position-relative" formGroupName="metadata">
                <label class="form-label">{{ 'integrations.pipedriveForm.apiTokenLabel' | translate }}</label>
                <input
                  [type]="hideAllPasswords ? 'password' : 'text'"
                  class="form-control"
                  maxlength="255"
                  formControlName="api_token"
                  [placeholder]="'integrations.pipedriveForm.apiTokenPlaceholder' | translate"
                  required
                />

                <field-error-component
                  [field]="'metadata.api_token'"
                  [label]="'integrations.fields.apiToken' | translate"
                  [formGroup]="formGroup"
                />
                <i
                  class="bi icon-eye"
                  [ngClass]="hideAllPasswords ? 'bi-eye-slash' : 'bi-eye'"
                  (click)="togglePasswordVisibility()"
                ></i>
              </div>
              <span class="text-muted mt-1">
                {{ 'integrations.pipedriveForm.apiTokenHelp' | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="row">
  <div class="col-12 gap-2 d-flex justify-content-end pb-4">
    <button class="btn btn-outline-secondary" (click)="cancel()">
      {{ 'integrations.pipedriveForm.cancel' | translate }}
    </button>

    <button
      class="btn btn-primary"
      [disabled]="!formGroup.valid || loading"
      type="submit"
    >
      {{ !loading ? (isNew ? ('integrations.pipedriveForm.save' | translate) : ('integrations.pipedriveForm.update' | translate)) : "" }}
      @if (loading) {
      <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
      }
    </button>
  </div>
</div>
